import { useState, useEffect } from 'react';
import { useAppStore } from '../store/useAppStore';
import clsx from 'clsx';

const TEMPLATES = [
  { id: 't1', name: '国潮动森像素风', emoji: '🎨', preview: 'linear-gradient(135deg, #e63946, #f4a261)' },
  { id: 't2', name: '金玉满堂风', emoji: '✨', preview: 'linear-gradient(135deg, #ffd60a, #f4a261)' },
  { id: 't3', name: '水墨丹青风', emoji: '🖌️', preview: 'linear-gradient(135deg, #457b9d, #a8dadc)' },
];

export default function InvitationPanel({ eventId }: { eventId: number }) {
  const { invitations, loadInvitations } = useAppStore();
  const list = invitations[eventId] || [];
  const [selectedTemplate, setSelectedTemplate] = useState(TEMPLATES[0]);
  const [previewMode, setPreviewMode] = useState(false);

  useEffect(() => {
    loadInvitations(eventId);
  }, [eventId, loadInvitations]);

  const invitation = list[0];

  if (!invitation) {
    return (
      <div id="panel-invitation-empty" className="ac-card p-5 text-center">
        <span className="text-4xl">💌</span>
        <p className="text-gray-400 mt-2">暂无电子请帖，请在群聊中请神仙帮您制作</p>
      </div>
    );
  }

  return (
    <div id="panel-invitation" className="ac-card p-5">
      <div id="invitation-header" className="flex items-center gap-2 mb-4">
        <span className="text-2xl">💌</span>
        <h3 className="font-bold text-lg text-gray-800">电子请帖</h3>
        <span className="text-xs text-gray-400 ml-auto">神仙赐福 · 一键转发</span>
      </div>

      {/* 模板选择 */}
      <div className="flex gap-2 mb-4">
        {TEMPLATES.map((t) => (
          <button
            key={t.id}
            onClick={() => setSelectedTemplate(t)}
            className={clsx(
              'flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-medium border-2 transition-all',
              selectedTemplate.id === t.id
                ? 'border-red-400 bg-red-50'
                : 'border-amber-200 bg-white hover:bg-amber-50'
            )}
          >
            <span className="text-lg">{t.emoji}</span>
            {t.name}
          </button>
        ))}
      </div>

      {/* 请帖预览 */}
      <div
        className="relative rounded-2xl p-6 mb-4 overflow-hidden"
        style={{ background: selectedTemplate.preview }}
      >
        {/* 装饰 */}
        <div className="absolute top-2 right-2 text-3xl opacity-20">🏮</div>
        <div className="absolute bottom-2 left-2 text-3xl opacity-20">🎊</div>

        <div className="relative text-center text-white">
          <div className="text-4xl mb-2">💍</div>
          <h2 className="text-xl font-bold mb-3 drop-shadow">{invitation.title}</h2>

          <div className="bg-white/20 backdrop-blur rounded-xl p-4 mb-3">
            <p className="text-sm leading-relaxed drop-shadow">{invitation.content}</p>
          </div>

          <div className="grid grid-cols-2 gap-3 text-left">
            <div className="bg-white/20 backdrop-blur rounded-lg p-2">
              <p className="text-xs opacity-80">📅 时间</p>
              <p className="text-sm font-medium">{invitation.date}</p>
            </div>
            <div className="bg-white/20 backdrop-blur rounded-lg p-2">
              <p className="text-xs opacity-80">📍 地点</p>
              <p className="text-sm font-medium">{invitation.location}</p>
            </div>
          </div>
        </div>
      </div>

      {/* 操作按钮 */}
      <div className="flex gap-2">
        <button
          onClick={() => setPreviewMode(!previewMode)}
          className="flex-1 py-2.5 rounded-xl text-sm font-medium text-amber-700 bg-amber-50 border border-amber-200 hover:bg-amber-100"
        >
          👁️ {previewMode ? '收起预览' : '全屏预览'}
        </button>
        <button
          className="flex-1 py-2.5 rounded-xl text-sm font-bold text-white"
          style={{ background: '#07c160', boxShadow: '0 3px 0 #05a050' }}
        >
          💬 微信转发
        </button>
        <button
          className="flex-1 py-2.5 rounded-xl text-sm font-bold text-white"
          style={{ background: '#e63946', boxShadow: '0 3px 0 #b02a37' }}
        >
          📋 复制链接
        </button>
      </div>

      {previewMode && (
        <p className="text-xs text-gray-400 mt-2 text-center">
          * 演示版请帖，实际部署后将生成可分享的 H5 链接
        </p>
      )}
    </div>
  );
}
